import { useLocation, useNavigate } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen bg-black text-center px-4">
      <span className="absolute inset-0 flex items-center justify-center text-[20rem] font-black text-white/[0.03] select-none pointer-events-none">
        404
      </span>
      <div className="relative z-10">
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Page Not Found</h1>
        <p className="text-gray-400 text-base mb-2 font-mono">{location.pathname}</p>
        <p className="text-gray-500 text-sm mb-10">The page you're looking for doesn't exist.</p>
        <button
          onClick={() => navigate("/")}
          className="inline-flex items-center gap-2 bg-[#14B8A6] hover:bg-teal-400 text-black font-semibold px-8 py-3 rounded-full transition-colors duration-200"
        >
          Back to Home
        </button>
      </div>
    </div>
  );
}
